module.exports = __webpack_public_path__ + "static/media/HRP_logo_gross.e61c5b75.png";